import withReadOnly from '../ReadOnlyAbilityWrapper';
import AutoSizedTextArea from './AutoSizedTextArea';
import { wrapInLabel } from '../NewInputLabelWrapper';

export default withReadOnly(wrapInLabel(AutoSizedTextArea));
